import { Injectable } from '@angular/core';
import { MaintenanceFilter } from '@core/interfaces';
import moment from 'moment';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceFilterState {
  public onChangeFilter = new Subject<void>();
  public onClearFilter = new Subject<void>();

  public defaultQuery: MaintenanceFilter = {
    openedAt_lte: moment().endOf('day').toISOString(),
    openedAt_gte: moment().subtract(1, 'years').startOf('day').toISOString(),
    archived: false,
  };

  public query: MaintenanceFilter = this.defaultQuery;

  constructor() { }
}
